<template>
  <div>
    <div>
      <el-card :body-style="{ padding: '0px' }">
        <img :src="imageUrl"
             class="avatar">
        <div class="button-block">
          <el-button type="primary"
                     round
                     @click="toggleShow">
            Set Avatar
          </el-button>
        </div>
      </el-card>
    </div>
    <avatar-upload field="file"
                   @crop-success="cropSuccess"
                   @crop-upload-success="cropUploadSuccess"
                   @crop-upload-fail="cropUploadFail"
                   v-model="show"
                   :width="300"
                   :height="300"
                   :url="uploadUrl"
                   langType='en'
                   :headers="headers"
                   img-format="jpg"></avatar-upload>
  </div>
</template>


<script>
import AvatarUpload from 'vue-image-crop-upload';
export default {
  components: {
    AvatarUpload,
  },
  created() {
    this.axios({
      method: 'get',
      url: `/file/${this.$route.params.userID}/avatar`,
    }).then(res => {
      this.imageUrl = res.data.url;
    });
  },
  data() {
    return {
      
//      uploadUrl: `https://author.businessexpertpress.com/api/file/${
      uploadUrl: this.axios.defaults.baseURL + '/file/' +
        this.$route.params.userID +
      '/avatar',
      show: false,
      headers: { Authorization: 'Bearer ' + localStorage.token },
      imageUrl: '',
      currentDate: new Date(),
    };
  },
  methods: {
    toggleShow() {
      this.show = !this.show;
    },
    /**
     * crop success
     *
     * [param] imgDataUrl
     * [param] field
     */
    cropSuccess(imgDataUrl, field) {
//      console.log('aaa');
//      console.log(imgDataUrl);
      this.imageUrl = imgDataUrl;
    },
    /**
     * upload success
     *
     * [param] jsonData  server api return data, already json encode
     * [param] field
     */
    cropUploadSuccess(jsonData, field) {},
    /**
     * upload fail
     *
     * [param] status    server api return error status, like 500
     * [param] field
     */
    cropUploadFail(status, field) {
//            console.log('bbb');
//            console.log(status);
//            console.log(field);

    },
  },
};
</script>
<style lang="scss" scoped>
.el-card {
  padding: 0;
  text-align: center;
  img.avatar {
    text-align: center;
    display: block;
    width: 100%;
    height: 100%;
  }
  div.button-block {
    padding: 5% 10%;
    .el-button {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/user/AvatarUpload.vue